




















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { IIndicatorValue } from '@/model/datamart';
import { v4 as uuidv4 } from 'uuid';

import {
    required,
    requiredIf,
    maxLength,
    decimal
} from 'vuelidate/lib/validators';

import FilterBar from '@/components/Filters/FilterBar.vue';
import BaseTable from '@/components/Table/BaseTable.vue';
import BaseModalForm from '@/components/Form/BaseModalForm.vue';
import { IIndicator } from '@/model/meta';

export default Vue.extend({
    name: 'Tables',
    metaInfo: {
        title: 'Таблицы значений',
    },
    components: {
        FilterBar,
        BaseTable,
        BaseModalForm,
    },
    computed: {
        ...mapGetters('viewing', {
            preloader: 'getPreloader',
            failLoading: 'getFailLoading',
            activeFormRequest: 'getActiveFormRequest',
            failedFormRequest: 'getFailedFormRequest',
            gridData: 'getIndictorValuesGrid',
            devicesFilter: 'getActiveDevices',
            indicatorsFilter: 'getAbailableIndicators',
        }),
        ...mapGetters('auth', {
            getUserId: 'getUserId',
        }),
        filterSetting(): Array<any> {
            return [
                {
                    code: 'device',
                    filterType: 'search-select',
                    label: 'Устройство:',
                    dataSet: this.devicesFilter,
                    textField: 'name',
                    valueField: 'ALL_OBJECT',
                },
                {
                    code: 'indicator',
                    filterType: 'search-select',
                    label: 'Показатель:',
                    dataSet: this.indicatorsFilter,
                    masterValue: this.getDeviceFilterId(),
                    textField: 'name',
                    valueField: 'ALL_OBJECT',
                },
                {
                    code: 'period',
                    filterType: 'range-datetime',
                    label: 'Период:',
                },
            ];
        },
        formSettings(): Array<any> {
            return [
                {
                    name: 'timestamp',
                    idPrefix: 'timestamp-name',
                    labelText: 'Метка времени',
                    inputType: 'datetime',
                    errorText: 'Ошибка. Обязательный параметр.',
                    validations: {
                        required,
                    },
                },
                {
                    name: 'value',
                    idPrefix: 'value-name',
                    labelText: 'Значение',
                    inputType: 'input',
                    placeholder: 'Введите числовое значение показателя',
                    errorText: 'Ошибка. Обязательный параметр. Введите число.',
                    validations: {
                        required,
                        decimal,
                    },
                },
                /** {
                    name: 'textValue',
                    idPrefix: 'text-value-name',
                    labelText: 'Строковое значение',
                    inputType: 'input',
                    placeholder: 'Введите строковое значение показателя',
                    errorText:
                        'Ошибка. Необходимо заполнить хотя бы одно из значений (строковое или числовое). Максимум 250 символов.',
                    validations: {
                        required: requiredIf(function(form: IIndicatorValue) {
                            return (
                                form.value === undefined || form.value === null
                            );
                        }),
                        maxLength: maxLength(250),
                    },
                }, */
            ];
        },
    },
    methods: {
        ...mapActions('viewing', {
            resetForm: 'resetForm',
            loadDevices: 'loadActiveDevices',
            setIndicators: 'setAvailableIndicators',
            cleanIndicators: 'cleanAvailableIndicators',
            loadData: 'loadValuesGrid',
            createItem: 'createIndicatorValue',
            deleteItem: 'deleteIndicatorValue',
            updateItem: 'updateIndicatorValue',
            resetGridData: 'resetGridData',
        }),
        inputHandler() {
            if (this.filters['device'] !== undefined) {
                this.setIndicators(this.filters['device']).then(() => {
                    this.emptyObject = this.getEmptyObject();
                    this.disableCreate = this.getDisableCreate();
                });
            } else {
                this.emptyObject = this.getEmptyObject();
                this.disableCreate = this.getDisableCreate();
            }
            this.filterCompleted = this.getFilterCompleted();
        },
        refreshAction() {
            if (this.filterCompleted) {
                this.loadData({
                    device: this.filters['device'],
                    indicator: this.filters['indicator'],
                    begin: this.filters['period'][0],
                    end: this.filters['period'][1],
                });
            }
        },
        getDeviceFilterId(): string {
            if (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null
            ) {
                return this.filters['device']['sensorDeviceId'];
            }
            return '';
        },
        editModalShow(selectObj: IIndicatorValue): void {
            this.editMode = 'edit';
            this.formShow = true;
            this.selected = selectObj;
        },
        newModalShow(): void {
            this.editMode = 'new';
            this.formShow = true;
        },
        deleteModalShow(selectObj: IIndicatorValue): void {
            this.selected = selectObj;
            this.deleteShow = true;
        },
        submitForm(editObj: IIndicatorValue): void {
            if (this.editMode === 'new') {
                this.createItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            } else {
                this.updateItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            }
        },
        submitDeleteForm(editObj: IIndicatorValue): void {
            this.deleteItem(editObj).then((result: boolean) => {
                if (result === true) this.closeModalForm();
            });
        },
        closeModalForm(): void {
            this.resetForm();
            this.formShow = false;
            this.deleteShow = false;
        },
        getEmptyObject() {
            let deviceTempId = '';
            let indicatorTempId = '';

            if (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null
            ) {
                deviceTempId = this.filters['device']['sensorDeviceId'];
            }

            if (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null &&
                this.filters['device'].availableIndicators !== undefined &&
                this.filters['indicator'] !== undefined &&
                this.filters['indicator'] !== null
            ) {
                const exists = (this.filters['device']
                    .availableIndicators as Array<IIndicator>).find(
                    x =>
                        x.indicatorId ===
                        this.filters['indicator']['indicatorId']
                );
                if (exists !== undefined && exists !== null)
                    indicatorTempId = this.filters['indicator']['indicatorId'];
            }

            return {
                indicatorValueId: uuidv4(),
                sensorDeviceId: deviceTempId as string | undefined,
                indicatorId: indicatorTempId as string | undefined,
                timestamp: new Date(),
                value: undefined as number | undefined,
                textValue: undefined as string | undefined,
            };
        },
        getDisableCreate(): boolean {
            return (
                this.emptyObject.sensorDeviceId === undefined ||
                this.emptyObject.sensorDeviceId === '' ||
                this.emptyObject.indicatorId === undefined ||
                this.emptyObject.indicatorId === '');
        },
        getFilterCompleted(): boolean {
            return (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null &&
                this.filters['indicator'] !== undefined &&
                this.filters['indicator'] !== null &&
                this.filters['period'] !== undefined &&
                this.filters['period'] !== null &&
                this.filters['period'].length > 1
            );
        },
    },
    mounted() {
        this.loadDevices(this.getUserId);
        this.resetGridData();
        this.disableCreate = this.getDisableCreate();
    },
    data() {
        return {
            filters: {} as any,
            fields: [
                {
                    key: 'timestamp',
                    label: 'Время',
                    sortable: true,
                    isDatetime: true
                },
                { key: 'value', label: 'Значение', sortable: true },
                /** {
                    key: 'textValue',
                    label: 'Строковое значение',
                    sortable: true
                } */
            ],
            selected: undefined as undefined | IIndicatorValue,
            formShow: false,
            deleteShow: false,
            editMode: 'new' as 'new' | 'edit',
            emptyObject: {
                indicatorValueId: uuidv4(),
                sensorDeviceId: '' as string | undefined,
                indicatorId: '' as string | undefined,
                timestamp: undefined as Date | undefined,
                value: undefined as number | undefined,
                textValue: undefined as string | undefined,
            },
            disableCreate: false,
            sortBy: 'timestamp',
            sortDesc: false,
            filterCompleted: false as boolean,
        };
    }
});
